module.exports = __webpack_public_path__ + "img/bg-6.ae4840b6.jpg";